import * as React from "react";
import { SendHorizontal } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";

interface ChatInputProps {
    onSend: (message: string) => void;
    disabled?: boolean;
    maxLength?: number;
}

export function ChatInput({
    onSend,
    disabled,
    maxLength = 1000,
}: ChatInputProps) {
    const [value, setValue] = React.useState("");
    const [isComposing, setIsComposing] = React.useState(false);

    const handleSubmit = (e?: React.FormEvent) => {
        e?.preventDefault();
        if (!value.trim() || disabled) return;
        onSend(value);
        setValue("");
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        // 日本語IMEなどの変換中Enterは送信しない
        if (e.isComposing || isComposing) return;
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    };

    const handleCompositionStart = () => setIsComposing(true);
    const handleCompositionEnd = () => setIsComposing(false);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = e.target.value;
        if (newValue.length <= maxLength) {
            setValue(newValue);
        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="relative flex w-full flex-col gap-1.5 rounded-lg border bg-background p-3 shadow-sm focus-within:ring-1 focus-within:ring-ring"
        >
            <Textarea
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onCompositionStart={handleCompositionStart}
                onCompositionEnd={handleCompositionEnd}
                placeholder="質問を入力してください..."
                className="resize-none border-0 bg-transparent shadow-none focus-visible:ring-0"
                style={{ fontSize: '14px', height: '50px', minHeight: '50px', maxHeight: '50px', padding: '8px' }}
                disabled={disabled}
                rows={2}
            />
            <div className="flex items-center justify-between">
                <span className="text-muted-foreground" style={{ fontSize: '11px' }}>
                    {value.length} / {maxLength}
                </span>
                <Button
                    type="submit"
                    size="icon"
                    disabled={!value.trim() || disabled}
                    className="h-7 w-7 rounded-full bg-emerald-600 hover:bg-emerald-700"
                >
                    <SendHorizontal className="h-3.5 w-3.5" />
                    <span className="sr-only">送信</span>
                </Button>
            </div>
        </form>
    );
}
